angular
  .module('ui-ng-ax')
  .directive(
    'title',
    function phxAxTitleAnnouncer($rootScope, DelegateResponder, phxAxTitleAnnouncerDelegateConfiguration) {
      'use strict';

      return {
        scope: false,
        restrict: 'E',
        link: DelegateResponder(phxAxTitleAnnouncerDelegateConfiguration, function (scope, element, attrs) {
          /**
           *  @desc Automatic title change detector based on routes, Service to change titles dynamically.
           */

          const defaultTitle = element.html();
          //Set Default title on start
          element.html(defaultTitle);

          //Set a live region to announce the page changes
          let titleAlertAnnouncer = angular.element('body').find('#pageTitleAnnouncer');

          if (_.isEmpty(titleAlertAnnouncer)) {
            titleAlertAnnouncer = angular.element(
              "<div id='pageTitleAnnouncer' role='status' class='sr-only hide-read' aria-live='polite'></div>"
            );
            angular.element('body').append(titleAlertAnnouncer);
          }

          //Get page title from route data configs or use default
          const getComposedTitle = (toState) => {
            if (!toState || !toState.data) {
              return defaultTitle;
            }
            let composedTitle = toState.data.pageTitle || toState.data.viewTitle;
            composedTitle = composedTitle ? `${composedTitle} | ${defaultTitle}` : defaultTitle;
            //noinspection Eslint
            return scope.titleSetManually ? scope.title : toState.data ? composedTitle : defaultTitle;
          };

          //Update live region to announce "<page title> page loaded" on route change finish
          $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, error) {
            element.html(getComposedTitle(toState));
            titleAlertAnnouncer.html(getComposedTitle(toState) + ' Page Loaded');
            scope.titleSetManually = false;
          });

          scope.announceTitle = function announceTitle(title) {
            element.html(title);
            titleAlertAnnouncer.html(title + ' Page Loaded');
            scope.titleSetManually = false;
          };

          scope.announceChange = function announceChange(message) {
            titleAlertAnnouncer.html(message);
          };

          scope.updateTitle = function updateTitle(title) {
            element.html(`${title} | ${defaultTitle}`);
          };
        })
      };
    }
  )
  .constant('phxAxTitleAnnouncerDelegateConfiguration', {
    uniqueComponent: 'title-announcer',
    vocabulary: {
      // set Title for OnEnter in routes
      setTitle: function (scope, element, attrs, event, title) {
        scope.title = title;
        scope.titleSetManually = true;
      },
      // Set and announce title
      announceTitle: function (scope, element, attrs, event, title) {
        scope.titleSetManually = true;
        scope.announceTitle(title);
      },
      // Set and announce title
      announceChange: function (scope, element, attrs, event, message) {
        scope.announceChange(message);
      },
      // Set and announce title
      updateTitle: function (scope, element, attrs, event, title) {
        scope.updateTitle(title);
      }
    }
  })
  .service(
    'phxAxTitleAnnouncerDelegate',
    function phxAxTitleAnnouncerDelegate(DelegateController, phxAxTitleAnnouncerDelegateConfiguration) {
      DelegateController(this, phxAxTitleAnnouncerDelegateConfiguration);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-ax/src/components/phx_ax_title_announcer/phx_ax_title_announcer.es.js